// import { useState } from "react";

export function handleImageModal(id, setModalState) {
  return setModalState(id);
}
const Modal = ({ modalState, setModalState, imageList }) => {
  // const [modalState, setModalState] = useState(false);
  // function handleImageModal(id) {
  //   return setModalState(id);
  // }
  // console.log('image list >> ',imageList);
  if (!modalState) return null;
  function handleClose() {
    setModalState(null);
  }
  function handleNext() {
    setModalState({
      image: 'https://cms.madebyparry.com' + imageList[modalState.index + 1],
      index: modalState.index + 1
    });
  }
  function handlePrev() {
    setModalState({
      image: 'https://cms.madebyparry.com' + imageList[modalState.index - 1],
      index: modalState.index - 1
    });
  }

  return (
    <div
      onClick={() => handleClose(null)}
      className="modal-wrapper-background"
      // style={{
      //   position: "fixed",
      //   top: 0,
      //   left: 0,
      //   width: "100%",
      //   height: "100%",
      //   background: "rgba(0, 0, 0, 0.5)",
      //   display: "flex",
      //   alignItems: "center",
      //   justifyContent: "center",
      // }}
    >
      <div 
        className="modal-wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        {/* {children} */}
        {/* <div className="close-wrapper"> */}
        {/*   <span className="close-button" onClick={() => handleClose()}>⨉</span> */}
        {/* </div> */}
        <div className="image-wrapper">
          <img className="modal-image" src={modalState.image}/>
        </div>
        <div className="button-wrapper">
          {
            modalState.index > 0 ? 
            <button
              onClick={() => handlePrev()}
            >{'<'}</button>
            :
            <button
              onClick={() => handleClose()}
            >{'X'}</button>
            // <button></button>
          }
          <span>{modalState.index + 1} / {imageList.length}</span>
          {
            modalState.index != imageList.length - 1 ? 
            <button
              onClick={() => handleNext()}
            >{'>'}</button>
            :
            <button
              onClick={() => handleClose()}
            >{'X'}</button>
            // <button></button>
          }
        </div>
      </div>
    </div>
  );

  // return (
  //   <div
  //     onClick={onClose}
  //     style={{
  //       position: "fixed",
  //       top: 0,
  //       left: 0,
  //       width: "100%",
  //       height: "100%",
  //       background: "rgba(0, 0, 0, 0.5)",
  //       display: "flex",
  //       alignItems: "center",
  //       justifyContent: "center",
  //     }}
  //   >
  //     <div
  //       style={{
  //         color: "#222",
  //         background: "white",
  //         height: 150,
  //         width: 240,
  //         margin: "auto",
  //         padding: "2%",
  //         border: "2px solid #000",
  //         borderRadius: "10px",
  //         boxShadow: "2px solid black",
  //       }}
  //     >
  //       <p>No bitches</p>
  //       <p>{post.id}</p>
  //       <p>{post.attributes.PostTitle}</p>
  //       <p>{post.attributes.PostBody}</p>
  //       <p>{post.attributes.PostCategory}</p>
  //       {children}
  //     </div>
  //   </div>
  // );
};

// export function handleModal(){
//   const [modalState, setModalState] = useState(false);
//   function handleImageModal(id) {
//     return setModalState(id);
//   }
// }

export default Modal;
